<script setup lang="ts">
import { VueDatePicker } from '@vuepic/vue-datepicker'
import { fr } from 'date-fns/locale'
import dayjs, { Dayjs } from 'dayjs'
import { computed } from 'vue'

const model = defineModel<Dayjs | null>({ default: null })

const props = withDefaults(defineProps<{
  minDate?: Dayjs | null
  maxDate?: Dayjs | null
  disabledDates?: Dayjs[]
}>(), {
  minDate: null,
  maxDate: null,
  disabledDates: () => []
})

const dateValue = computed(() => model.value ? model.value.toDate() : null)
const minDateValue = computed(() => props.minDate ? props.minDate.toDate() : undefined)
const maxDateValue = computed(() => props.maxDate ? props.maxDate.toDate() : undefined)
const disabledDateValues = computed(() => props.disabledDates.map((date) => date.toDate()))
const formats = { input: 'dd/MM/yyyy', preview: 'dd/MM/yyyy' }
const timeConfig = { enableTimePicker: false }

function handleUpdate(value: Date | null) {
  model.value = value ? dayjs(value) : null
}
</script>

<template>
  <VueDatePicker
    :model-value="dateValue"
    :min-date="minDateValue"
    :max-date="maxDateValue"
    :disabled-dates="disabledDateValues"
    :locale="fr"
    :formats="formats"
    :time-config="timeConfig"
    :input-attrs="{ clearable: false }"
    text-input
    auto-apply
    class="sancare-date-picker"
    @update:model-value="handleUpdate"
  >
    <template #dp-input="{ value, onInput, onEnter, onTab, onKeypress, onPaste, onBlur }">
      <input
        type="text"
        class="form-control sancare-date-picker__input"
        :value="value"
        @input="onInput"
        @keydown.enter="onEnter"
        @keydown.tab="onTab"
        @keypress="onKeypress"
        @paste="onPaste"
        @blur="onBlur"
      >
    </template>
  </VueDatePicker>
</template>

<style lang="scss" scoped>
.sancare-date-picker__input {
  // Fixed to the exact length of the 'dd/MM/yyyy' format so the input never
  // needs to be measured/resized at runtime.
  box-sizing: content-box;
  width: 10ch;
  cursor: pointer;
}
</style>
